<div class="row">
  <div style="margin-bottom: 15px" *ngIf="volume == 0; else info">
    <h6 style="margin-bottom: 20px">
      <span style="color: #f49602">&#9679;</span>
      &nbsp; Please add the process data that describes the PU foam simulation
    </h6>

    <div class="box">
      <div style="display: inline-block">
        <usimweb-icon [icon]="'warning'" style="color: #f49602"></usimweb-icon>
      </div>

      <div style="display: inline-block">
        <p style="position: relative; top: -5px; left: 10px">
          The geometry is still meshing, there is no possibility to predict the simulation time without the geometry
          volume.
        </p>
      </div>
    </div>
  </div>

  <ng-template #info>
    <h6 style="margin-bottom: 30px">
      <span style="color: #f49602">&#9679;</span>
      &nbsp; Please add the process data that describes the PU foam simulation
    </h6>
  </ng-template>

  <div class="col-6">
    <usimweb-dropdown
      placeholder="Mass parameter"
      [values]="massParameters"
      [key]="key"
      [value]="value"
      [default]="massParameter"
      (selectionChange)="massParameter = $event"
      (selectionChange)="massSelectionChanged(massParameterValue)"
    ></usimweb-dropdown>
  </div>

  <div class="col-6">
    <usimweb-form-input
      placeholder="Value"
      [value]="defaultMassParameter"
      [type]="inputType.FLOAT_NUMBER"
      [required]="true"
      [min]="massParameterMin"
      [max]="massParameterMax"
      (selectionChange)="massParameterChanged($event)"
    ></usimweb-form-input>
  </div>
</div>

<div class="row">
  <div class="col-6">
    <usimweb-dropdown
      placeholder="Injection parameter"
      [values]="timeParameters"
      [key]="key"
      [value]="value"
      [default]="timeParameter"
      (selectionChange)="timeParameter = $event"
      (selectionChange)="timeSelectionChanged(timeParameterValue)"
    ></usimweb-dropdown>
  </div>

  <div class="col-6">
    <usimweb-form-input
      placeholder="Value"
      [value]="defaultTimeParameter"
      [type]="inputType.FLOAT_NUMBER"
      [required]="true"
      [min]="timeParameterMin"
      [max]="timeParameterMax"
      (selectionChange)="timeParameterChanged($event)"
    ></usimweb-form-input>
  </div>
</div>

<div *ngIf="simulationType === simulationTypeEnum.VARIOTHERM">
  <usimweb-button-icon [icon]="'add'" fontColor="white"></usimweb-button-icon>
</div>

<usimweb-table style="margin-top: 15px" [data]="dataTableSource" [columns]="curveColumns"></usimweb-table>
